import { NgModule } from "@angular/core";
import { LeadTableComponent } from "./lead-table/lead-table.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { MarkdownModule } from "ngx-markdown";
import { MaterialModule } from "src/app/material/material.module";
import { LoaderModule } from "../loader/loader.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { LeadVerificationComponent } from './lead-verification/lead-verification.component';
import { FormFieldsModule } from "../form-fields/form-fields.module";
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { ControlsModule } from "../controls/controls.module";
import { QuickAddCompanyComponent } from './quick-add-company/quick-add-company.component';
import { ReportsModule } from "../reports/reports.module";
import { CustomerTableComponent } from './customer-table/customer-table.component';
import { KycVerificationComponent } from './kyc-verification/kyc-verification.component';
import { LeadCreateComponent } from './lead-create/lead-create.component';

@NgModule({
    declarations: [
        LeadTableComponent,
        LeadVerificationComponent,
        UserVerificationComponent,
        QuickAddCompanyComponent,
        CustomerTableComponent,
        KycVerificationComponent,
        LeadCreateComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        FlexLayoutModule,
        Ng2SearchPipeModule,
        DragDropModule,
        NgSelectModule,
        LoaderModule,
        MarkdownModule,
        PipesModule,
        FormFieldsModule,
        ControlsModule,
        ReportsModule,
    ],
    exports: [
        LeadTableComponent,
        LeadVerificationComponent,
        UserVerificationComponent,
        QuickAddCompanyComponent,
        CustomerTableComponent,
        KycVerificationComponent,
        LeadCreateComponent
    ]
})
export class LeadsModule { }